import { combineReducers } from 'redux'

/* eslint-disable */
export * as participants from './participants'
export * as profile from './profile'
export * as registration from './registration'
export * as signoff from './signoff'
export * as assessors from './assessors'

import participants from './participants'
import profile from './profile'
import registration from './registration'
import signoff from './signoff'
import assessors from './assessors'
/* eslint-enable */

export default combineReducers({
  participants,
  profile,
  registration,
  signoff,
  assessors
})
